import React from 'react';

const travellerCount = (props) => (
    <div className={`u-verticalAlignBottom u-size15x15 u-inlineBlock u-backgroundColorPrimary u-borderRadius50 u-textColorWhite ml-1`}>
        <span className={`u-block u-fontSize11`}>{props.children}</span>
    </div>
);

export default travellerCount;



// WEBPACK FOOTER //
// ./src/components/Travellers/TravellerCount/TravellerCount.js